import type { EnergyEfficiencyClass } from '@einwert/valuation-api-client'

export const ENERGY_CLASS_LABELS: Record<EnergyEfficiencyClass, string> = {
    a_plus: 'A+',
    a: 'A',
    b: 'B',
    c: 'C',
    d: 'D',
    e: 'E',
    f: 'F',
    g: 'G',
    h: 'H',
    unknown: 'N/A',
}

export const energyClassColors: Record<EnergyEfficiencyClass, string> = {
    a_plus: '#68933E',
    a: '#76A330',
    b: '#94B94A',
    c: '#BACD7F',
    d: '#F6CC09',
    e: '#F4B615',
    f: '#EEA212',
    g: '#DB6B28',
    h: '#DA5138',
    unknown: '#B0B0B0',
}
